<app-page-header title="Partner Manager details"></app-page-header>
<div class="row">
  <div class="col-md-4">
    <app-manager-general-info [data]="managerProfile"></app-manager-general-info>
  </div>
  <div class="col-md-4">
    <app-manager-rapido-account [data]="managerProfile"></app-manager-rapido-account>
  </div>
</div>